/**
    * @fileoverview Generated Platform Configuration
    * @description Auto-generated during token build process
    * @generated 2025-12-08T15:10:36.626Z
    */

    export const CURRENT_PLATFORM = "mobile" as const;

    export type Platform = "tv" | "web" | "mobile";
  